import 'ol/ol.css';
import { twMerge } from 'tailwind-merge';
import { useMagnifierLoupe } from '@/components/Map/MagnifierLoupe/utils/useMagnifierLoupe';
import { MAGNIFIER_LOUPE_ROLE } from '@/components/Map/MagnifierLoupe/MagnifierLoupe.constants';

export const MagnifierLoupe = (): JSX.Element => {
  const { containerRef, targetRef } = useMagnifierLoupe();

  return (
    <div
      ref={containerRef}
      role={MAGNIFIER_LOUPE_ROLE}
      style={{ position: 'fixed', display: 'none', visibility: 'hidden' }}
      className={twMerge(
        'pointer-events-none z-50 h-[320px] w-[320px] overflow-hidden rounded-full',
        'border-4 border-white bg-white drop-shadow-primary',
      )}
    >
      <div ref={targetRef} className="h-full w-full" />
    </div>
  );
};
